import './invoiceItem.css'; // Import the CSS file for styling
import React, { useEffect, useState } from 'react';

const InvoiceItem = ({ invoice, lineItems }) => {
  const [productTypes, setProductTypes] = useState({});

  useEffect(() => {
    const groupData = () => {
      const grouped = {};
      lineItems.forEach((item) => {
        let key = '';

        // Determine the key based on item's name
        if (item.name.includes('Consultation')) {
          key = 'Consultation Fees';
        } else if (item.name.includes('Admission')) {
          key = 'Admission Fees';
        } else if (item.name.includes('Observation')) {
          key = 'Observation Fees';
        } else {
          key = 'Lab and Medication';
        }

        // Update grouped object
        grouped[key] = (grouped[key] || 0) + item.item_total;
      });
      setProductTypes(grouped);
    };

    if (lineItems.length > 0) {
      groupData();
    }
  }, [lineItems]);

  return (
    <div className='itemsSections'>
      <table className="invoice-table">
        <tbody>
          {lineItems.length > 0 ? (
            Object.keys(productTypes).map((key) => (
              <tr key={key}>
                <td className='typeCell'>{key}</td>
                <td>{productTypes[key].toFixed(2)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2">No Records Found!</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceItem;
